import React from "react";

function NewsLetter() {
  return (
    <>
      <div className='bg-gradient-to-r from-blue-400 via-blue-400 to-green-400 py-14 text-white text-center'>
        <h1 className='uppercase text-2xl sm:text-3xl'>
          SUBSCRIBE TO OUR NEWSLETTER
        </h1>
        <p className='py-3 text-sm'>
          Far far away, behind the word mountains, far from the countries
          Vokalia and Consonantia, there
          <br />
          live the blind texts. Separated they live in
        </p>
        <div className='flex justify-center items-center pt-10 sm:pt-14 overflow-hidden'>
          <div>
            <input
              type='email'
              placeholder='Enter email address'
              className='rounded-l-full border-white border p-4 outline-none bg-transparent placeholder-white pr-0 sm:pr-24'
            />
          </div>
          <div>
            <button className='rounded-r-full border-white border p-4 w-full px-5'>
              Subscribe
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsLetter;
